import { render, staticRenderFns } from "./ObjectFit.vue?vue&type=template&id=1b4c8e1a&"
import script from "./ObjectFit.vue?vue&type=script&lang=js&"
export * from "./ObjectFit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports